enum DataPlatform {
    WEB = 'WEB',  MOBILE = 'MOBILE', S3 = 'S3',
}

export default DataPlatform;